// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3bXzP","colMaxWidth":"Table_colMaxWidth__2PPS0"};